import { Table } from "antd";
import WeaDragula from "../wea-dragula";
import isFunction from "lodash/isFunction";
import "./index.less";
import middleware from "../../middleware";
class WeaTable extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    if (this.props.draggable) {
      let { dataSource, className = "", style } = this.props;
      return (
        <WeaDragula
          container=".ant-table-tbody"
          canDrag={clickDom => jQuery(clickDom).hasClass("icon-coms-move")}
          datas={dataSource}
          getKeyFromData={this.getRowKey}
          getKeyFromDom={this.getKeyFromDom}
          onDrop={this.onDrop}
        >
          <div
            className={`wea-new-table wea-new-table-draggable ${className}`}
            style={style}
          >
            <Table {...this.props} columns={this.getColumns()} />
          </div>
        </WeaDragula>
      );
    } else {
      return (
        <div className="wea-new-table">
          <Table {...this.props} columns={this.getColumns()} />
        </div>
      );
    }
  }

  getKeyFromDom = dom => {
    return jQuery("span.icon-coms-move", dom).attr("data-index");
  };

  onDrop = datas => {
    isFunction(this.props.onDrop) && this.props.onDrop(datas);
  };
  getColumns = () => {
    let { columns } = this.props;
    if (Array.isArray(columns)) {
      columns = columns.map(col => {
        if (col.isHtml) {
          return {
            ...col,
            render: (text, record, index) => {
              return <span dangerouslySetInnerHTML={{ __html: text }} />;
            }
          };
        }
        return col;
      });
      if (this.props.draggable) {
        columns = [
          {
            key: "drag",
            dataIndex: "drag",
            width: 60,
            render: (text, record, index) => {
              return (
                <span
                  data-index={this.getRowKey(record, index)}
                  className="icon-coms-move cursor-pointer"
                />
              );
            }
          }
        ].concat(columns);
      }
    }
    return columns;
  };

  getRowKey = (record, index) => {
    const rowKey = this.props.rowKey;
    if (typeof rowKey === "function") {
      return rowKey(record, index);
    }
    return typeof record[rowKey] !== "undefined" ? record[rowKey] : index;
  };
}

WeaTable.defaultProps = {
  rowKey: "key",
  draggable: false
};

const Com = middleware(WeaTable, "WeaTable");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-table/index.js